<template>
  <v-list-item class="py-1" :to="to" :ripple="false">
    <v-list-item-avatar width="22" height="22" min-width="22">
      <v-img :src="item.loan.lender.logo" />
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title class="font-weight-bold font-size--16">{{
        item.loan.lender.name
      }}</v-list-item-title>
      <v-list-item-subtitle class="color--nice-grey font-size--14">
        {{ item.loan.title }}
      </v-list-item-subtitle>

      <v-row v-if="!error" no-gutters class="mt-2 font-weight-black font-size--18">
        <v-col style="flex-grow: 5">
          {{ trimDecimalZeros(toPercentage(item.minInterestRate, 2)) }}%
        </v-col>
        <v-col style="flex-grow: 7">
          <span class="font-size--13">최대</span>
          {{ commaFormat(parseInt(item.maxLoanAmount / 10000)) }}만원
        </v-col>
      </v-row>
      <v-row v-else no-gutters class="mb-n1" style="margin-top: 2px">
        <v-col>
          <p
            class="mb-0 font-size--10 px-2 py-1 rounded-4"
            style="color: #ef1449; background-color: #ffbbcb"
          >
            일시적으로 대출 정보를 가져오지 못했습니다. 여기를 눌러 다시 시도해보세요.
          </p>
        </v-col>
      </v-row>
    </v-list-item-content>

    <v-list-item-action class="ml-1" v-if="aciton">
      <v-btn icon>
        <v-icon color="grey lighten-1">
          {{ error ? 'mdi-refresh' : 'mdi-chevron-right' }}
        </v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { toPercentage, trimDecimalZeros } from '@/util/mathUtil'
import { commaFormat } from '@/filter/number'

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },

    aciton: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    to() {
      if (this.aciton === false || this.error) {
        return ''
      }

      // loan의 code가 funda_woori_crowd 인 경우 우리동네 메인으로 이동
      if (this.item.loan.code === 'funda_woori_crowd') {
        return { name: 'woori-crowd' }
      }

      // loan의 code가 funda_pull_revenue인 경우 당겨받기 한도 조회 페이지로 이동
      if (this.item.loan.code === 'funda_pull_revenue') {
        return { name: 'loan/pull-revenue' }
      }

      if (this.$route.name !== 'compare-loans/detail') {
        return {
          name: 'compare-loans/detail',
          params: { uuid: this.item.uuid },
        }
      }

      return ''
    },

    error() {
      // TODO 에러 조건 채워넣기
      return false
      // this.item.loan.lender.name === '펀다'
    },
  },

  methods: {
    toPercentage,
    trimDecimalZeros,
    commaFormat,
  },
}
</script>

<style lang="scss" scoped>
// after divider
.v-list-item {
  background-color: white;

  &::after {
    background-color: #0000001f;
    height: 1px;
    min-height: 1px;
    width: 100%;
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
